module.exports = __webpack_public_path__ + "img/dollar.e65b7a3d.svg";